module.exports = __webpack_public_path__ + "img/ava3.776cc2a7.svg";